module.exports = __webpack_public_path__ + "img/si.af560a54.png";